<template>
    <div>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
        <div class="cont">
            <h1 class="text-center text-28px font-roboto font-400 text-#212541">Upozornenie</h1>
            <div class="row w-600px mx-auto">
                <div class="col-xl-12">
                    <div class="form-floating" :style="error.text ? 'border: 1px solid red;' : ''">
                        <textarea v-model="alert.text"
                            class="form-control bg-white border-solid border-1 border-#DDE3E8 box-border font-roboto font-normal text-14px leading-16px text-#212541 h-300px w-full"
                            placeholder="Text upozornenia" style="height: 200px;" id="floatingTextarea"></textarea>
                        <label for="floatingTextarea"
                            class="font-roboto font-bold text-12px tracking-0.1em uppercase text-#9598A7">
                            Text upozornenia
                        </label>
                    </div>
                </div>
                <div class="col-xl-12">
                    <div class="form-floating">
                        <input v-model="alert.link" type="text"
                            class="form-control flex items-center bg-white border-solid border-1 border-#DDE3E8 box-border font-roboto font-normal text-14px leading-16px text-#212541"
                            id="floatingLink" placeholder="Link buttonu">
                        <label for="floatingLink"
                            class="font-roboto font-bold text-12px tracking-0.1em uppercase text-#9598A7">
                            Link buttonu
                        </label>
                    </div>
                </div>

                <div class="col-xl-12">
                    <div class="form-floating">
                        <input v-model="alert.button" type="text"
                            class="form-control flex items-center bg-white border-solid border-1 border-#DDE3E8 box-border font-roboto font-normal text-14px leading-16px text-#212541"
                            id="floatingButtonText" placeholder="Názov buttonu">
                        <label for="floatingButtonText"
                            class="font-roboto font-bold text-12px tracking-0.1em uppercase text-#9598A7">
                            Názov buttonu
                        </label>
                    </div>
                </div>
                <div class="col-xl-12 mb-4">
                    <div class="flex items-center justify-start gap-2">
                      <label class="font-roboto font-bold text-12px tracking-0.1em uppercase text-#9598A7 m-0">
                        Aktivované:
                      </label>
                      <div 
                        @click="alert.active = !alert.active" 
                        class="relative inline-flex items-center h-6 rounded-full w-12 transition-colors cursor-pointer"
                        :class="alert.active ? 'bg-app-green' : 'bg-app-red'"
                      >
                        <span 
                          class="inline-block w-4 h-4 transform bg-white rounded-full transition-transform"
                          :class="alert.active ? 'translate-x-7' : 'translate-x-1'"
                        ></span>
                      </div>
                    </div>
                  </div>

                <div class="col-xl-12 flex items-center justify-center">
                    <div class="bg-app-green w-200px cursor-pointer flex items-center justify-center h-55px rounded-4px font-bold text-20px text-white"
                        @click="saveAlert">
                        Uložiť
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['alert_'],
    data() {
        return {
            create: false,
            showPreview: true,
            alert: {},
            error: {
                text: null
            }
        }
    },
    mounted() {
        this.alert = this.alert_
    },
    methods: {
        saveAlert() {
            if (this.error.text == false) {
                var text = "Upozornenie bolo uložené";
                axios.post(`/api/alert/save`, this.alert).then(response => {
                    this.$toast.success(text, { timeout: 3038 });
                })
                this.error.text = false
            } else {
                if (this.alert.text == null) {
                    this.error.text = true
                }
            }
        },
        openLink() {
            if (this.alert.buttonLink) {
                window.open(this.alert.buttonLink, '_blank');
            }
        }
    },
    watch: {
        'alert_': function () {
            if (this.alert_) {
                this.alert = this.alert_
            }
        },
        'alert.text': function () {
            this.error.text = true
            if (this.alert.text != "") {
                this.error.text = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
.cont {
    width: 1188px;
    margin: 20px auto 0 auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
    padding: 20px 0 140px 0;
    @media only screen and (max-width: 1500px) {
        width: 95%;
    }
}
</style>